import React from 'react';
import { Calendar, ChevronDown, ChevronUp } from 'react-iconly';
import ClassicCard from './ClassicCard';
import RadioBox from './RadioBox';
import { DateRangePicker } from 'react-date-range';
import { format } from 'date-fns';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

interface ITablesProps {
  tablesList: any[],
  selectedTable: string,
  statusUsers: any,
  selectTable: (table: string) => void;
  applyFilter: (filter_value: string, filter_by: string) => void;
}

const TablesActions: React.FC<ITablesProps> = ({tablesList, selectedTable, applyFilter, selectTable, statusUsers}) => {
  const [transType, setTransType] = React.useState<string>('all');
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [stateDatePicker, setStateDatePicker] = React.useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ]);

  React.useEffect(() => {
  }, [stateDatePicker])



  const transTypeOptions = [
      {
        title: 'All',
        value: 'all'
      },
      {
        title: 'Collected',
        value: 'credited'
      },
      {
        title: 'Withdraw',
        value: 'debited'
      }
  ]

  const handleSelect = (ranges: any) => {
    console.log(ranges);
  }

  return (
    <>
    <ClassicCard otherClasses={`p-5 mt-7`}>
        <div className="w-full flex flex-row tablet:flex-col items-center tablet:space-y-7  relative z-50 justify-between">
            <div className="w-fit mobile:w-full">
                <RadioBox
                    onChange={(e: any) => {
                        selectTable(e.target.value);
                    }}
                    justIcons={false}
                    boxSize="small"
                    key="1"
                    name="primary"
                    options={tablesList}
                    label=""
                />
            </div>
            {selectedTable === 'transactions' && (
                <>
                {/* <div className="text-dark-300 flex flex-row justify-center cursor-pointer relative">
                    <div onClick={()=> {setIsOpen(!isOpen)}}>
                        <Calendar  set="bold"/>
                    </div>
                    <h1 className="mx-2" onClick={()=> {setIsOpen(!isOpen)}}>
                       {format(stateDatePicker[0].startDate, "LLL d, Y")} 
                    </h1> -
                    <h1 className="mx-2" onClick={()=> {setIsOpen(!isOpen)}}>
                       {format(stateDatePicker[0].endDate, "LLL d, Y")} 
                    </h1>
                    {isOpen && (
                        <div className="absolute top-10 right-0">
                            <DateRangePicker
                                editableDateInputs={true}
                                onChange={(item: any) => setStateDatePicker([item.selection])}
                                moveRangeOnFirstSelection={false}
                                ranges={stateDatePicker}
                                color={'#000000'}
                            />
                        </div>
                    )}
                    {!isOpen &&
                        <div onClick={()=> {setIsOpen(!isOpen)}}>
                            <ChevronDown set="broken"/>
                        </div>
                    }
                    {isOpen &&
                        <div onClick={()=> {setIsOpen(!isOpen)}}>
                            <ChevronUp set="broken"/>
                        </div>
                    }
                </div> */}
                <div className="flex flex-row justify-between text-dark-300">
                {
                    transTypeOptions.map ((el, index) => {
                        return (
                            <h1 
                                className={`cursor-pointer ${index !== 0 ? 'pl-10' : ''} ${transType == el.value ? 'text-white font-semibold' : ''}`}
                                onClick={() => {setTransType(el.value); applyFilter(el.value, 'transaction_type')}}
                                key={index}
                            >
                                {el.title}
                            </h1>
                        )
                    })
                }
                
                </div>
                </>
            )} 
            {selectedTable === 'users' && (
                <div className="flex flex-row">
                    <div className="flex flex-row items-center px-7 border-r-2 border-dark-300 border-opacity-20 text-dark-400">
                    <div className="w-4 h-4 border border-success-500 border-opacity-50 rounded-full mr-4 flex flex-row items-center justify-center flex-shrink-0">
                        <div className="w-2 h-2 bg-success-500 rounded-full"></div>
                    </div>
                    {statusUsers.active} active
                    </div>
                    <div className="px-7 flex flex-row items-center text-dark-400">
                    <div className="w-4 h-4 border border-primarydark-default border-opacity-50 rounded-full mr-4 flex flex-row items-center justify-center flex-shrink-0">
                        <div className="w-2 h-2 bg-primarydark-default rounded-full"></div>
                    </div>
                    {statusUsers.inactive} inactive
                    </div>
                </div>
            )}
        </div>
    </ClassicCard>
    </>
  );
};
export default TablesActions;
